import { useStateContext } from '../contexts/ContextProvider';
const Sidebar = () => {
  const { currentColor, activeMenu, setActiveMenu, screenSize } = useStateContext();

 
};

export default Sidebar;